import { render, staticRenderFns } from "./tenantTnc.vue?vue&type=template&id=5dfb0e28&"
import script from "./tenantTnc.vue?vue&type=script&lang=js&"
export * from "./tenantTnc.vue?vue&type=script&lang=js&"
import style0 from "./tenantTnc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dfb0e28')) {
      api.createRecord('5dfb0e28', component.options)
    } else {
      api.reload('5dfb0e28', component.options)
    }
    module.hot.accept("./tenantTnc.vue?vue&type=template&id=5dfb0e28&", function () {
      api.rerender('5dfb0e28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/components/tenantTnc.vue"
export default component.exports